const sortDataByDate = (data, key) => {
  let sortedData = data.slice().sort((a, b) => {
    let aDate = new Date(a[key]);
    let bDate = new Date(b[key]);
    return bDate - aDate;
  });
  return sortedData;
};
export default sortDataByDate;

export const sortDatesDesc  = (dates = []) =>
  [...dates].sort((a, b) => {
    const [dayA, monthA, yearA] = a.split("-");
    const [dayB, monthB, yearB] = b.split("-");

    return (
      new Date(yearB, monthB - 1, dayB) - new Date(yearA, monthA - 1, dayA)
    );
  });
